import {getCurrencyFractionDigits} from './getCurrencyFractionDigits';

const DECIMAL_BASE = 10;

// 2000000 -> 20 000 EUR, the inverse of toMinorUnits.
export const fromMinorUnits = (minorAmount: number, currency: string) =>
  minorAmount / DECIMAL_BASE ** getCurrencyFractionDigits(currency);
